<template>
    <div class="LCDcontainer">
        <div class="LCD">

            <div class="hours">{{ today }}</div>
            <div class="divider">&nbsp; - &nbsp;</div>
            <div class="hours">{{ hours }}</div>
            <div class="divider">:</div>
            <div class="minutes">{{ minutes }}</div>
            <div class="divider">:</div>
            <div class="seconds">{{ seconds }}</div>
            <div class="divider">&nbsp;</div>
            <div class="seconds">{{ ampm }}</div>
        </div>
    </div>
</template>

<script>

export default {
    name: "DigitalClock",
    data() {
        return {
            hours: 0,
            minutes: 0,
            seconds: 0,
            today: "Sat Jan 01 2022",
            ampm: "AM",
        }
    },
    mounted() {
        setInterval(() => this.setTime(), 1000)
    },
    methods: {
        setTime() {
            //     const timeElapsed = Date.now();
            //   const today = new Date(timeElapsed);

            const date = new Date();

            let hours = date.getHours();
            let minutes = date.getMinutes();
            let seconds = date.getSeconds();
            var ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12;
            hours = hours <= 9 ? `${hours}`.padStart(2, 0) : hours;
            minutes = minutes <= 9 ? `${minutes}`.padStart(2, 0) : minutes;
            seconds = seconds <= 9 ? `${seconds}`.padStart(2, 0) : seconds;
            this.hours = hours;
            this.minutes = minutes;
            this.seconds = seconds;
            this.today = date.toDateString();
            this.ampm = ampm;
        }
    }
}
</script>


<style scoped>
.LCD {
    display: flex;
    align-items: center;
}

.LCD>div {
    font-family: "alarm clock";
    font-size: x-large;
}
</style>
<style>
@import url("https://fonts.googleapis.com/css2?family=Wallpoet&display=swap");

.LCDcontainer {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    color: #FFF;
    background: linear-gradient(118deg, #7367f0, rgba(115, 103, 240, 0.7));
    text-align: center;
    vertical-align: middle;
    padding: 0 15px;
    border-radius: 25px;
    font-weight: bold;
}

@font-face {
    font-family: "alarm clock";
    src: url('fonts/alarm.ttf');

}
</style>